import validator from 'validator';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

// Email validation function
export function isEmailValid(email: string): boolean {
  return validator.isEmail(email);
}

// Phone number validation function
export function isPhoneNumberValid(phone: string): boolean {
  const phoneNumber = parsePhoneNumberFromString(phone);
  return phoneNumber ? phoneNumber.isValid() : false;
}
